"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaDraft = void 0;
class MediaDraft {
    constructor(mediaFile, text) {
        this.mediaFile = mediaFile;
        this.text = text;
    }
    updateText(text) {
        this.text = text;
        return this;
    }
}
exports.MediaDraft = MediaDraft;
